import { ViewModel } from '../../../../../models/view.model';
import { useAtomValue } from 'jotai';
import { selectedDateByViewPFJ } from '../../../state/PageStateJ';
import { dateToPlainDateString } from '../../../../../util/date-utilts';

export function usePortfolioGridFileName(view: ViewModel) {
  const date = useAtomValue(selectedDateByViewPFJ(view.id));
  return `${view.name}-${dateToPlainDateString(date)}`;
}
